const USER_ROLE = {
  ADMIN: "admin",
  USER: "user",
  SUPPLIER: "supplier",
  REQUESTED_SELLER: "requestedSeller",
};

export default USER_ROLE;
